import type { ListBatchJobItemsParams } from "../../../../../lib/corpusApi";

export type DocumentSectionsRefreshTabKey = "refreshed" | "skipped" | "failed";

export interface DocumentSectionsRefreshTabConfig {
  label: string;
  /** Query params sent to GET /batch-jobs/:id/items for this tab. */
  apiFilters: Pick<ListBatchJobItemsParams, "status" | "outcome">;
}

/** One tab per refresh outcome, plus the documents the run failed on. Order is display order. */
export const DOCUMENT_SECTIONS_REFRESH_TABS: Record<
  DocumentSectionsRefreshTabKey,
  DocumentSectionsRefreshTabConfig
> = {
  refreshed: {
    label: "Refreshed",
    apiFilters: { outcome: "refreshed" },
  },
  skipped: {
    label: "Skipped",
    apiFilters: { outcome: "skipped" },
  },
  failed: {
    label: "Failed",
    apiFilters: { status: "failed" },
  },
};

export const DOCUMENT_SECTIONS_REFRESH_TAB_ORDER: DocumentSectionsRefreshTabKey[] = [
  "refreshed",
  "skipped",
  "failed",
];
